<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-content"
        style="width: 100%; border: none;"
      >
        <div
          class="position-relative chat-chanel-wrapper"
          style="height: 100%;"
        >
          <div
            style="width: 100%; overflow: auto; height: 100%;"
          >
            <List
              :channels="channels"
              :total="total"
              :loading="loading"
              @filter="listChannel"
              @handover="openHandover"
              @detail="onChannelChange"
              @addOther="(e) => $emit('addOther', e)"
              @assign="(c, t, a) => $emit('assign', c, t, a)"
              @price="c => $emit('price', c)"
              @cancel="c => $emit('cancel', c)"
              @goToChat="c => $emit('goToChat', c)"
            />
          </div>
        </div>
      </div>
    </div>
    <chat-settings-model
      ref="openSettingsModal"
      @reloadChannel="reloadData"
    />
    <chat-shortcut-model ref="openShortcutModal" />
    <HandoverServiceSystemModal
      ref="handoverServiceSystemModal"
      :active-channel="activeChannel"
      @success="reloadData"
    />
  </div>
</template>

<script>
import {
  BModal,
  BAvatar,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormSelect,
} from 'bootstrap-vue'
import InfiniteLoading from 'vue-infinite-loading'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect'
import { bus } from '@/libs/bus'
import useJwt from '@/auth/jwt/useJwt'
// import QueueAlert from '@/components/QueueAlert.vue'
import NSearchContainer from '@/components/NSearchContainer'
import NSearchInput from '@/components/NSearchInput'
import Repository from '@/repositories/RepositoryFactory'
import store from '@/store'
import ChatShortcutModel from './ChatShortcutModel.vue'
import DateInputs from './searchDate.js'
import ChatSettingsModel from './ChatSettingsModel.vue'
import ChatContact from './ChatContact.vue'
import HandoverOperatorModal from './HandoverOperatorModal.vue'
import HandoverServiceSystemModal from './components/HandoverServiceSystemModal.vue'
import List from './List.vue'

export default {
  components: {
    NSearchContainer,
    NSearchInput,
    // BSV
    BModal,
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BDropdownForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    // QueueAlert,

    // 3rd party
    InfiniteLoading,

    // SFC
    ChatContact,
    NAsyncSingleSelect,

    // Component
    ChatSettingsModel,
    ChatShortcutModel,
    HandoverOperatorModal,
    HandoverServiceSystemModal,
    List,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    channels: {
      type: Array,
      default: () => [],
    },
    activeChannel: {
      type: Object,
      default: () => {},
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    identifier: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowSearch: !!this.$route.query.search,
      assignIcon: 'UserIcon',
      filterOptions: [],
      query: {
        operator: this.$route.query.operator || null,
        departmentId: this.$route.query.departmentId || null,
        type:
          this.$route.query.type
          || store.state.app.serviceSystemQuery.type
          || 'allServices',
        status: this.$route.query.status || '',
        // search: this.$route.query.search || '',
        // searchType: this.$route.query.searchType || 'm',
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
        cache: this.$route.query.cache,
        serviceSystemId: this.$route.query.serviceSystemId || null,
        from: this.$route.query.from || null,
        // channel: this.$route.query.channel || null,
        // channelId: this.$route.query.channelId || null,
        // msgStartDate: this.$route.query.msgStartDate || null,
      },
      searchTypeOptions: [
        { value: 'm', text: this.$t('general.message') },
        { value: 'c', text: this.$t('general.channel') },
      ],
      dialogVisible: false,
      statusDialogVisible: false,
      isModifierPressed: false,
      debouncedNavigate: null,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  created() {
    if (this.$route.query.from === 'chat') {
      this.query.status = ''
      this.$route.query.status = ''
      this.changeFilter('')
    }

    const serviceSystemQuery = {}
    if (this.query.cache != 'no') {
      Object.keys(store.state.app.serviceSystemQuery).forEach(key => {
        if (!this.query[key]?.trim()) {
          serviceSystemQuery[key] = store.state.app.serviceSystemQuery[key]
        } else if (this.query[key] == 'noCache') {
          serviceSystemQuery[key] = ''
        }
      })
    }
    this.query = {
      ...this.query,
      ...serviceSystemQuery,
      ...(this.$route.query.from === 'chat' ? { status: '' } : {}),
    }
    this.$nextTick(() => {
      this.mapFilterOption(this.query.type)
      this.changeFilter(this.query.status)

      // bus.$on('notificationClick', type => {
      //   if (type == 'service') {
      //     console.log('service')
      //     this.mapFilterOption(this.query.type)
      //     this.changeFilter(this.query.status)
      //   }
      // })
    })
    this.debouncedNavigate = _.debounce(direction => {
      const channel = this.findChannelAdjacent(direction)
      if (channel) {
        // Visual update only
        this.scrollToActive()
        this.$nextTick(() => {
          // Actual channel change
          this.onChannelChange(channel)
        })
      }
    }, 100, {
      leading: true,
      trailing: false,
      maxWait: 300,
    })
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    // bus.$off('notificationClick')
    if (this.debouncedNavigate) {
      this.debouncedNavigate.cancel()
    }
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },
  methods: {
    openHandover() {
      // this.$refs.openHandover.show()
      this.$refs.handoverServiceSystemModal.show()
    },
    reset() {
      this.$refs.search.reset()
      this.updateQuerySting()
    },
    resetDate() {
      this.query.startDate = ''
      this.query.endDate = ''
      this.updateQuerySting()
      this.toggleDialog()
      this.$emit('filter', this.query)
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible
    },
    reloadData() {
      // this.$emit('closeChannel', {})
      this.search()
    },
    openSettings() {
      this.$refs.openSettingsModal.show()
    },
    openShortcut() {
      this.$refs.openShortcutModal.show()
    },
    listChannel(query) {
      this.$emit('load-channel', query)
    },
    onChangeOperator() {
      // this.query.search = ''
      // this.query.status = ''
      this.updateQuerySting()
      this.$emit('filter', this.query)
    },
    onChangeDepartment() {
      // this.query.search = ''
      // this.query.status = ''
      this.updateQuerySting()
      this.$emit('filter', this.query)
    },
    onChangeSearchType() {
      this.updateQuerySting()
      this.$emit('filter', this.query)
    },
    onChannelChange(channel) {
      this.$emit('open-chat', channel)
    },
    changeFilter(status) {
      let channel = null
      if (this.$route.query.channel) {
        channel = this.$route.query.channel
      }
      this.query.status = status
      this.updateQuerySting()
      if (channel) {
        this.query.channel = channel
      }
      this.$emit('filter', this.query)
    },
    changeOperator(type) {
      // this.query.search = ''
      // this.query.status = ''
      this.query.operator = ''
      this.mapFilterOption(type)
      this.query.type = type
      // if (type === 'unassign') {
      //   this.query.status = 'unassign'
      // }
      this.updateQuerySting()
      this.$emit('filter', this.query)
    },
    mapFilterOption() {
      // if (type == 'unassign') {
      //   this.filterOptions = []
      // } else {
      this.filterOptions = [
        {
          value: '',
          text: 'chat.all',
        },
        {
          value: 'pending',
          text: 'status.pending',
        },
        {
          value: 'accepted',
          text: 'status.accepted',
        },
        {
          value: 'processing',
          text: 'status.processing',
        },
        {
          value: 'pendingPrice',
          text: 'status.pendingPrice',
        },
        {
          value: 'hold',
          text: 'status.hold',
        },
        {
          value: 'cancel',
          text: 'status.cancel',
        },
        {
          value: 'completed',
          text: 'status.completed',
        },
        {
          value: 'resolved',
          text: 'status.closed',
        },
        // {
        //   value: 'unresolved',
        //   text: 'status.unresolved',
        // },
      ]
      // }
    },
    searching() {
      this.isShowSearch = !this.isShowSearch
      if (!this.isShowSearch && this.query.search) {
        this.query.search = ''
        this.search()
      }
    },
    search() {
      if (this.query.endDate) {
        const endDate = new Date(this.query.endDate)
        endDate.setSeconds(59)
        this.query.endDate = endDate.toISOString()
      }
      this.updateQuerySting()
      this.$emit('filter', this.query)
      this.dialogVisible = false
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query })
      store.commit('app/UPDATE_SERVICE_SYSTEM_QUERY', {
        ...this.query,
        from: undefined,
        serviceSystemId: undefined,
        channel: undefined,
        channelId: undefined,
      })
    },
    findChannelAdjacent(direction) {
      if (!this.activeChannel?.id) {
        return this.channels[0] ? this.channels[0] : null
      }
      const currentIndex = this.channels.findIndex(item => item.id === this.activeChannel?.id)

      if (currentIndex === -1) return this.channels[0] ? this.channels[0] : null

      let newIndex
      if (direction === 'next') {
        newIndex = currentIndex + 1 >= this.channels.length ? 0 : currentIndex + 1
      } else {
        newIndex = currentIndex - 1 < 0 ? this.channels.length - 1 : currentIndex - 1
      }

      return this.channels[newIndex]
    },
    handleKeyDown(event) {
      if (event.metaKey || event.ctrlKey) {
        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault()
            this.debouncedNavigate('previous')
            break

          case 'ArrowDown':
            event.preventDefault()
            this.debouncedNavigate('next')
            break
        }
      }
    },

    handleKeyUp(event) {
      if (event.key === 'Control' || event.key === 'Meta') {
        this.isModifierPressed = false
      }
    },

    scrollToActive() {
      this.$nextTick(() => {
        const activeElement = this.$refs.activeChannel?.[0]?.$el
        const { container } = this.$refs

        if (activeElement && container) {
          const containerRect = container.getBoundingClientRect()
          const elementRect = activeElement.getBoundingClientRect()

          // Calculate scroll position to center the element
          const scrollTop = (
            activeElement.offsetTop
            - (container.clientHeight / 2)
            + (elementRect.height / 2)
          )

          if (container) {
            // Smooth scroll to position
            container.scrollTo({
              top: scrollTop,
              behavior: 'smooth',
            })
          }
        }
      })
    },
  },
  setup() {
    return {
      dateInputs: DateInputs,
    }
  },
}
</script>

<style scoped>
.input-group-text {
  padding: 0 !important;
}

.custom-select:focus {
  box-shadow: none !important;
}

.fixed-dialog {
  position: fixed;
  height: 274px;
  top: 100px;
  left: 400px;
  width: 300px;
  z-index: 1000;
  background-color: #fff;
  border: 0px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sidebar-left {
  width: 100% !important;
}
</style>

<style>
.group-department .vs__dropdown-option--disabled {
  font-size: 12px;
  margin-left: -10px;
  color: black !important;
  font-weight: bold !important;
  opacity: 1;
}
</style>
